<template>
  <div>
    <v-bottom-sheet v-model="stShowHighlights" v-if="showMobile" hide-overlay>
        <v-sheet class="text-right">
          <v-btn
            icon
            color="primary"
            class="btn-close"
            @click="showHighlights"
          >
            <v-icon class="font-size-32 white rounded-circle"> mdi-close-circle</v-icon>
          </v-btn>
          <Highlight @close-highlight="showHighlights" />
        </v-sheet>
    </v-bottom-sheet>
    <v-dialog v-model="stShowHighlights" v-else hide-overlay>
      <v-btn
        icon
        color="primary"
        class="btn-close"
        @click="showHighlights"
      >
        <v-icon class="font-size-32 white rounded-circle"> mdi-close-circle</v-icon>
      </v-btn>
      <Highlight @close-highlight="showHighlights" />
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import Highlight from './bookUtils/Highlight.vue'

export default {
  data() {
    return {
      bottomHighlightSheet: false
    };
  },
  components: {
    Highlight,
  },
  methods: {
    ...mapActions('bookReading', [
      'showHighlights',
    ]),
  },
  computed: {
    ...mapState({
      stShowHighlights: (state) => state.bookReading.mobileTools.showHighlights,
      showMobile: (state) => state.isMobile,
    })
  }
}
</script>

<style lang="scss">

.v-bottom-sheet{
  position: relative;
  .btn-close{
    position: absolute;
    right: 24px;
    left: inherit;
    top: 1em;
    z-index: 10;
  }
}


</style>